import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { IJobApplication } from "@/data/job-applications";
import { formatFullName } from "@/data/persons";
import { Flex } from "@/eworkitComponents/components";
import { useFormats } from "@/hooks/Formats";
import { List, ListItem } from "@/views/components/List";

export interface IAssignmentRelatedJATableProps {
  jobApplication: IJobApplication;
  onRowClick?: (jobRequest: IJobApplication) => void;
}

export const AssignmentRelatedJAList: FC<IAssignmentRelatedJATableProps> = memo(({ jobApplication, onRowClick }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();

  return (
    <List innerShadows={false}>
      <ListItem onClick={() => onRowClick?.(jobApplication)}>
        <Flex direction="column" innerMargin="xs">
          <Flex innerMargin="sm">
            <Flex width={6}>
              <Text color="grey2">{t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.ID_TABLE_HEADER")}</Text>
            </Flex>

            <Flex width={6}>{jobApplication.externalSystemId ?? "-"}</Flex>
          </Flex>

          <Flex innerMargin="sm">
            <Flex width={6}>
              <Text color="grey2">
                {t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.COMPANY_TABLE_HEADER")}
              </Text>
            </Flex>

            <Flex width={6}>{jobApplication.consultantProfile.sharedProfile?.company.name}</Flex>
          </Flex>

          <Flex innerMargin="sm">
            <Flex width={6}>
              <Text color="grey2">
                {t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.CANDIDATE_TABLE_HEADER")}
              </Text>
            </Flex>

            <Flex width={6}>
              <Text wordBreak="all" whiteSpace="pre-wrap">
                {formatFullName(jobApplication.consultantProfile)}
              </Text>
            </Flex>
          </Flex>

          <Flex innerMargin="sm">
            <Flex width={6}>
              <Text color="grey2">
                {t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.SUBMISSION_DATE_TABLE_HEADER")}
              </Text>
            </Flex>

            <Flex width={6}>
              <Text wordBreak="all" whiteSpace="pre-wrap">
                {formatDate(jobApplication.createdDate)}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </ListItem>
    </List>
  );
});
